export const prefersReducedMotion = () =>
  window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const scrollToSection = (id, navigate) => {
  const el = document.getElementById(id);
  if (!el) {
    if (navigate) navigate(`/#${id}`);
    return;
  }
  el.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
  window.history.replaceState(null, "", `#${id}`);
};
